import { PickingGroupPackage } from "api/wms/models";
import { useCreateTableColumns } from "utilities/tableColumnsUtilities/createTableColumns/createTableColumns";

export const usePickingWorkspaceColumns = () =>
  // TODO: type
  useCreateTableColumns<PickingGroupPackage>(({ columnHelper }) => {
    return [];
  });
